<!-- @format -->

<div id="pdp-tech-specs">
	<hmf-accordion
		label="Specifications"
		size="large"
		icon="tool-straighten"
		[expandOverContent]="false">
		<div
			class="tech-specs-body label-base"
			itemprop="specs"
			[innerHTML]="techSpecs() | dcsgSanitizeHtml"></div>
	</hmf-accordion>
</div>
